/* Copy to Shopify assets/havjoy-job-sse.js. No token or database key needed. */
function watchHavjoyJob(sessionId, {
  onUpdate = () => {},
  onComplete = () => {},
  onFailed = () => {},
  onConnectionError = () => {},
  apiBase = "https://api.havjoy.com",
  maxWaitMs = 10 * 60 * 1000,
} = {}) {
  if (!sessionId) throw new Error("Missing session ID");
  const query = new URLSearchParams({ session_id: sessionId });
  const base = apiBase.replace(/\/$/, "");
  let source = null;
  let stopped = false;
  let polling = false;
  let pollTimer;
  let initialTimer;
  let requestController;
  let deadlineTimer;

  function stop() {
    stopped = true;
    source?.close();
    source = null;
    clearTimeout(pollTimer);
    clearTimeout(initialTimer);
    clearTimeout(deadlineTimer);
    requestController?.abort();
  }

  function deliver(job) {
    if (stopped) return;
    const terminal = ["completed", "failed", "cancelled"].includes(job.status);
    if (terminal) stop(); // Close before callbacks, including native reconnects.
    onUpdate(job); // Same payload as /check_job_status.
    if (job.status === "completed") onComplete(job);
    else if (terminal) onFailed(job);
  }

  async function poll() {
    if (stopped) return;
    requestController = new AbortController();
    const controller = requestController;
    const requestTimer = setTimeout(() => controller.abort(), 10000);
    let job;
    try {
      const response = await fetch(`${base}/check_job_status?${query}`, {
        cache: "no-store",
        credentials: "omit",
        signal: controller.signal,
      });
      if ([400, 401, 403, 404].includes(response.status)) {
        stop();
        onConnectionError(new Error(`Job status HTTP ${response.status}`));
        return;
      }
      if (!response.ok) throw new Error(`Job status HTTP ${response.status}`);
      job = await response.json();
      if (!job || typeof job.status !== "string") job = null;
    } catch (error) {
      // Temporary network/server failure: retry without marking the job failed.
    } finally {
      clearTimeout(requestTimer);
    }
    if (stopped) return;
    if (job) deliver(job);
    if (!stopped) pollTimer = setTimeout(poll, 3000);
  }

  function fallback() {
    if (stopped || polling) return;
    polling = true;
    source?.close();
    source = null;
    clearTimeout(initialTimer);
    poll(); // Only one transport and one in-flight polling request.
  }

  deadlineTimer = setTimeout(() => {
    stop();
    onConnectionError(new Error("Stopped waiting for job; check again using the same session ID."));
  }, maxWaitMs);

  if (typeof EventSource === "undefined") {
    fallback();
  } else {
    initialTimer = setTimeout(fallback, 15000);
    try {
      source = new EventSource(`${base}/sse/job_status?${query}`);
      source.addEventListener("job_status", (event) => {
        if (stopped || polling) return;
        let job;
        try { job = JSON.parse(event.data); }
        catch { fallback(); return; }
        if (!job || typeof job.status !== "string") { fallback(); return; }
        clearTimeout(initialTimer);
        deliver(job);
      });
      source.addEventListener("stream_error", fallback);
      // The backend rotates streams after 5 min. Polling then resumes safely.
      source.addEventListener("reconnect", fallback);
      source.onerror = fallback;
    } catch {
      fallback();
    }
  }
  return stop;
}
